// extractNormalizedWord is frozen: production fluency records are keyed on its
// output, so any change (Unicode/NFC awareness included) rekeys live data. The
// keyspace is deliberately English-ASCII and NFC-sensitive; known hole: the
// vocabulary's apostrophe entries (ma'am, y'all, o'clock) are unreachable by
// exact headword lookup. corpus-db's resolveHeadwords matches on this key.

// Greedy (first ** to last **); extractNormalizedWord's keys depend on it.
export const BOLD_MARKER_PATTERN = /\*\*(.+)\*\*/;

export function extractNormalizedWord(word: string): string {
  const match = BOLD_MARKER_PATTERN.exec(word);
  const focusWord = match?.[1] ?? word;
  return focusWord.toLowerCase().replace(/[^a-z]/g, "");
}

export function extractTargetWord(word: string): string {
  const match = BOLD_MARKER_PATTERN.exec(word);
  return match?.[1] ?? word;
}

// speechSynthesis may read asterisks aloud. Not BOLD_MARKER_PATTERN: speech
// needs single and unmatched asterisks gone too, and the context words kept.
export function stripMarkdownForSpeech(text: string): string {
  return text.replace(/\*+/g, "").replace(/\s+/g, " ").trim();
}
